import type { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import type { Options } from '@splidejs/splide';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { RoundedButton } from '../form/Button';
// eslint-disable-next-line
import '@splidejs/react-splide/css';
import './slider-styling.scss';

const defaultOptions: Options = {
    type: 'loop',
    autoplay: true,
    interval: 10000, // 10 seconds.
};

interface ArrowButtonProps {
    buttonClasses: string;
    icon?: IconProp;
    iconClasses?: string;
    size?: SizeProp;
}

function ArrowButton({
    buttonClasses,
    icon = faChevronRight,
    iconClasses = 'text-primary',
    size = '1x', // Same as `xl`.
}: ArrowButtonProps): JSX.Element {
    return (
        <button className={buttonClasses}>
            <FontAwesomeIcon icon={icon} className={iconClasses} size={size} />
        </button>
    );
}

interface SlideButton {
    link: string;
    text: string;
}

interface Slide {
    src: string;
    title: string;
    description: string;
    button?: SlideButton;
}

interface SliderProps {
    slides: Slide[];
    options?: Options;
}

function Slider({ slides, options = defaultOptions }: SliderProps): JSX.Element {
    return (
        <Splide hasTrack={false} options={options} aria-label={gettext('IMAGE_SLIDER')}>
            <SplideTrack>
                {slides.map((slide, index) => (
                    <SplideSlide key={index}>
                        <div className="slide-main">
                            <img src={slide.src} alt={`Slider Image ${index}`} />
                            <div className="slide-content">
                                <h2 className="text-2xl font-semibold">{slide.title}</h2>
                                <p className="text-xs font-normal">{slide.description}</p>
                                {slide.button && (
                                    <RoundedButton
                                        type="button"
                                        onClick={() => window.open(slide.button?.link, '_blank')}
                                        variant="icon"
                                        flex
                                    >
                                        {slide.button.text}
                                    </RoundedButton>
                                )}
                            </div>
                        </div>
                    </SplideSlide>
                ))}
            </SplideTrack>
            <div className="splide__arrows">
                <ArrowButton buttonClasses="splide__arrow splide__arrow--prev" />
                <ArrowButton buttonClasses="splide__arrow splide__arrow--next" />
            </div>
        </Splide>
    );
}

export default Slider;
